import React from 'react';
import { Box } from '@mui/material';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { ButtonGroup } from '../../ButtonGroup';
import { State } from '../redux';

const PointsFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type ComponentState = State['awardConfiguration']['pointsPerAward'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  fieldDisabled: (field: Fields) => boolean;
};
const PointsPerAward: React.FC<Props> = (props) => {
  const { fieldDisabled, pointRounding, points } = props;

  return (
    <Box>
      <Box my={4}>
        <PointsFormInput
          id='points'
          label='Points to Award'
          readonly={fieldDisabled('points')}
          type='text'
          value={points}
          required={true}
        />
      </Box>

      <Box mb={4}>
        <ButtonGroup
          label='Point Rounding'
          name='pointRounding'
          readonly={fieldDisabled('pointRounding')}
          selectedValue={pointRounding}
        >
          <ButtonGroup.Option value='half_up'>Half Up</ButtonGroup.Option>
          <ButtonGroup.Option value='down'>Down</ButtonGroup.Option>
        </ButtonGroup>
      </Box>
    </Box>
  );
};

export { PointsPerAward };
